import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";

import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Carte from "./pages/Carte";
import Commander from "./pages/Commander";
import Boutiques from "./pages/Boutiques";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import MenuManager from "./pages/admin/MenuManager";
import EventsManager from "./pages/admin/EventsManager";
import PopupsManager from "./pages/admin/PopupsManager";
import ShopsManager from "./pages/admin/ShopsManager";
import IngredientsManager from "./pages/admin/IngredientsManager";
import CookieOfMonthManager from "./pages/admin/CookieOfMonthManager";
import NumberCakeGalleryManager from "./pages/admin/NumberCakeGalleryManager";
import CookiePersoGalleryManager from "./pages/admin/CookiePersoGalleryManager";
import ContactsManager from "./pages/admin/ContactsManager";
import ContactsTreated from "./pages/admin/ContactsTreated";

function NotFound() {
    return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
            <p className="font-handwritten text-5xl text-[#B07B66]">404</p>
            <h1 className="font-serif-display text-3xl text-[#2A1408] mt-2">
                Page introuvable
            </h1>
            <a href="/" className="brand-btn mt-6 inline-block">
                Retour à l'accueil
            </a>
        </div>
    );
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/carte" element={<Carte />} />
                        <Route path="/commander" element={<Commander />} />
                        <Route path="/boutiques" element={<Boutiques />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/mentions-legales" element={<MentionsLegales />} />
                        <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>

                    <Route path="/admin/login" element={<AdminLogin />} />

                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<AdminDashboard />} />
                        <Route path="menu" element={<MenuManager />} />
                        <Route path="events" element={<EventsManager />} />
                        <Route path="popups" element={<PopupsManager />} />
                        <Route path="shops" element={<ShopsManager />} />
                        <Route path="ingredients" element={<IngredientsManager />} />
                        <Route path="cookie-of-month" element={<CookieOfMonthManager />} />
                        <Route path="numbercake-gallery" element={<NumberCakeGalleryManager />} />
                        <Route path="cookie-perso-gallery" element={<CookiePersoGalleryManager />} />
                        <Route path="contacts" element={<ContactsManager />} />
                        <Route path="contacts/traites" element={<ContactsTreated />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
